module.exports = __webpack_public_path__ + "media/images/emblems/GW-GL-Glarus_Sued-65379be7c01c9f04a1b2fc9c5a3628fd.png";